module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showBox),
      expression: "showBox"
    }],
    staticClass: "scollTop",
    on: {
      "click": _vm.scrollTopFn
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/img/myCenter/top@2x.png")
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5b78426c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/scrollTop.vue
// module id = 1185
// module chunks = 67